export const fetchStudentCourses = async ({ BeURL }) => {
    try {
        // Validate BeURL
        if (!BeURL || typeof BeURL !== 'string') {
            console.error("Backend URL not provided or invalid")
            return {
                success: false,
                message: "Backend URL is not configured properly",
                courses: [],
                total: 0
            }
        }

        // Validate URL format
        try {
            new URL(`${BeURL}/fetch-student-courses`)
        } catch (urlError) {
            console.error("Invalid Backend URL format:", urlError)
            return {
                success: false,
                message: "Backend URL format is invalid",
                courses: [],
                total: 0
            }
        }

        const controller = new AbortController()
        const timeoutId = setTimeout(() => controller.abort(), 30000) // 30 second timeout

        const res = await fetch(`${BeURL}/fetch-student-courses`, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            signal: controller.signal
        })

        clearTimeout(timeoutId)

        // Validate response status
        if (!res.ok) {
            if (res.status === 401) {
                return {
                    success: false,
                    message: "Authentication required. Please login again.",
                    courses: [],
                    total: 0
                }
            }
            if (res.status === 403) {
                return {
                    success: false,
                    message: "Access denied. You don't have permission to access this resource.",
                    courses: [],
                    total: 0
                }
            }
            if (res.status === 404) {
                return {
                    success: false,
                    message: "API endpoint not found. Please contact support.",
                    courses: [],
                    total: 0
                }
            }
            if (res.status >= 500) {
                return {
                    success: false,
                    message: "Server error. Please try again later.",
                    courses: [],
                    total: 0
                }
            }
            
            throw new Error(`HTTP error! status: ${res.status}`)
        }

        // Validate response content type
        const contentType = res.headers.get("content-type")
        if (!contentType || !contentType.includes("application/json")) {
            console.error("Invalid response content type:", contentType)
            return {
                success: false,
                message: "Invalid response from server",
                courses: [],
                total: 0
            }
        }

        const data = await res.json()

        // Validate response structure
        if (!data || typeof data !== 'object') {
            console.error("Invalid response data")
            return {
                success: false,
                message: "Invalid data received from server",
                courses: [],
                total: 0
            }
        }

        // Ensure response has required properties
        return {
            success: data.success === true,
            message: data.message || (data.success ? "Success" : "Failed"),
            courses: Array.isArray(data.courses) ? data.courses : [],
            total: typeof data.total === 'number' ? data.total : 0
        }

    } catch (err) {
        console.error("Error in fetchStudentCourses:", err)

        // Handle specific error types
        if (err.name === 'AbortError') {
            return {
                success: false,
                message: "Request timeout. Please check your internet connection.",
                courses: [],
                total: 0
            }
        }

        if (err.name === 'TypeError' && err.message.includes('fetch')) {
            return {
                success: false,
                message: "Network error. Please check your internet connection.",
                courses: [],
                total: 0
            }
        }

        return {
            success: false,
            message: err.message || "An unexpected error occurred. Please try again later.",
            courses: [],
            total: 0
        }
    }
}